module.exports = __webpack_public_path__ + "static/media/fabric-color.231899b6.png";